module.exports = __webpack_public_path__ + "img/1.c4e4cf0b.png";